export default {
    "regulations": {
        "titles": "Documentos",
        "title": "Documento",
        "label": "@:regulations.titles",
        "list": {
            "buttons": {
                "item": "Documento"
            }
        }
    },
    "page_categories": {
        "titles": "Categorias",
        "title": "Categoria",
        "model": {
            "name": "Nome",
            "slug": "Slug",
            "description": "Descrição",
            "published_at": "Publicado em",
            "unpublished_at": "Despublicado em",
            "status": "Ativo",
            "roles": "Perfis de Acesso",
        },
        "list": {
            "name": "@:page_categories.model.name",
            "description": "@:page_categories.model.description",
            "status": "@:page_categories.model.status",
        },
        "help": {
            "roles": "Perfil de acesso à categoria, por defeito é público."
        }
    },
    "pages": {
        "titles": "Páginas",
        "title": "Página",
        "model": {
            "slug": "Slug",
            "title": "Titulo",
            "content": "Conteúdo",
            "category": "Categoria",
            "published_at": "Publicado em",
            "unpublished_at": "Despublicado em",
            "sidebar": {
                "title": "Painel Lateral",
                "show": "Mostrar",
            },
            "label": "Label",
            "icon": "Icon",
            "default": "Página Inicial",
            "order": "Ordem",
            "status": "Ativo",
            "roles": "Perfis de Acesso",
        },
        "list": {
            "order": "@:pages.model.order",
            "title": "@:pages.model.title",
            "label": "@:pages.model.label",
            "sidebar": "@:pages.model.sidebar.title",
            "status": "@:pages.model.status",
        },
        "help": {
            "order": "Ordem de apresentação.",
            "roles": "Perfil de acesso à página, por defeito é público."
        }
    },
}
